import ipv4Port from 'app/forms/validations/ipv4Port';

function fn(value) {
  if (value) {
    if (typeof value === 'string') {
      /*

      Expecting:
        udp://<ipNumber with port>
      Examples:
        udp://2.2.2.2
        udp://2.2.2.2:8080

      */
      const udpPrefix = 'udp://';
      if (!value.startsWith(udpPrefix)) {
        return false; // Must start with 'udp://'
      }
      value = value.substring(udpPrefix.length); // Remove 'udp://' prefix

      return ipv4Port.fn(value); // Validate the rest using ipv4Port validation
    }

    return true;
  }

  return true;
}

export default {
  message: 'Enter a valid IPv4 address starting with udp://. Optional port number is supported.',
  fn
};
